'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return Array.prototype.flatten || implementation;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/array.prototype.flatten/polyfill.js
// module id = 186
// module chunks = 0